export enum AssetFilterEnum {
  Customer_Org_Id = "customerOrgId",
  Customer_Org_Ag = "customerOrgAg",
  Customer_Org_We = "customerOrgWe",
  Asset_Ids = "assetIds",
  Asset_Type = "assetType",
  Exclude_Asset_Types = "excludeAssetTypes",
  Asset_Type_Name = "assetTypeName",
  Technology_ID = "technologyCode",
  Material_Number_Production = "materialNumberProduction",
  Machine_Group_Sis = "machineGroupSis",
  Business_Unit = "businessUnitSis",
  Trumpf_Subsidiary = "trumpfSubsidiarySis",
  Warranty_End_Before = "warrantyEndBefore",
  Product_Discontinued = "productDiscontinued",
  City = "city",
  Country = "countryIsoCode",
  Custom_Asset = "isCustomOnlyAsset",
  Root_Asset = "isRootAsset",
  Lock_Status = "lockStatus",
  Sparepart_Catalog_Available = "isSparepartCatalogAvailable",
  In_Order_Tracking = "isInOrderTracking"

}
